import Vue from 'vue'
import {careReceipt, hasAuthToken, portalRequest} from '@/intake/portalApi'

export const notificationState = Vue.observable({unreadCount: null})
let owner = null
let revision = 0
function currentOwner() {
  const token = typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null
  if (token !== owner) {
    owner = token
    revision += 1
    notificationState.unreadCount = null
  }
  return token
}
function count(value) {
  if (value === null || value === '') throw new Error('NOTIFICATION_RESPONSE_INVALID')
  const n = Number(value)
  if (!Number.isSafeInteger(n) || n < 0) throw new Error('NOTIFICATION_RESPONSE_INVALID')
  return n
}
function applyCount(value, requestOwner, requestRevision) {
  const n = count(value)
  if (currentOwner() === requestOwner && revision === requestRevision) notificationState.unreadCount = n
}

export function notificationRoute(item, lang = 'fa') {
  const target = item && item.target
  const id = target && target.id != null ? String(target.id).trim() : ''
  if (!id) return null
  if (target.type === 'SUPPORT_REQUEST' && /^[a-f\d-]{36}$/i.test(id)) return {name:'portalRequestDetail',params:{lang},query:{id}}
  if (target.type === 'THERAPIST_CHAT' && /^\d+$/.test(id)) return {name:'portalChat',params:{lang},query:{userId:id}}
  if (target.type === 'SESSION' && /^\d+$/.test(id)) return {name:'portalSessionDetail',params:{lang},query:{id}}
  return null
}

export function fetchClientNotifications(page = 1) {
  const requestOwner = currentOwner(), requestRevision = ++revision
  if (!hasAuthToken()) return Promise.reject(new Error('AUTH_REQUIRED'))
  return portalRequest('care','clientNotifications',{page,per_page:25}).then(careReceipt).then(data => {
    if (currentOwner() !== requestOwner) throw new Error('AUTH_REQUIRED')
    if (!Array.isArray(data.data)) throw new Error('NOTIFICATION_RESPONSE_INVALID')
    const normalized = {...data,current_page:count(data.current_page),last_page:count(data.last_page)}
    if (normalized.current_page < 1 || normalized.last_page < 1) throw new Error('NOTIFICATION_RESPONSE_INVALID')
    applyCount(data.unread_count,requestOwner,requestRevision)
    return normalized
  })
}

export function refreshNotificationUnreadCount() {
  const requestOwner = currentOwner(), requestRevision = ++revision
  if (!hasAuthToken()) { notificationState.unreadCount = null; return Promise.resolve(null) }
  return portalRequest('care','clientNotificationUnreadCount').then(careReceipt).then(data => {
    applyCount(data.unread_count,requestOwner,requestRevision)
    return notificationState.unreadCount
  })
}

export function readClientNotification(id) {
  const requestOwner = currentOwner(), requestRevision = ++revision
  if (!hasAuthToken()) return Promise.reject(new Error('AUTH_REQUIRED'))
  return portalRequest('care','readClientNotification',{notificationId:id},{}).then(careReceipt).then(data => {
    if (currentOwner() !== requestOwner) throw new Error('AUTH_REQUIRED')
    if (!data.notification || String(data.notification.id) !== String(id)) throw new Error('NOTIFICATION_RESPONSE_INVALID')
    applyCount(data.unread_count,requestOwner,requestRevision)
    return data.notification
  })
}
